<template>
<v-dialog v-model='dialog' width='320' >
  <template v-slot:activator="{ on, attrs }">
    <v-btn small flat
      v-if='appointmentId'
      :loading='request.loading'
      :disabled='disabled'
      v-bind="attrs"
      v-on="on"
      @click='step=0' >{{cta}}</v-btn>
  </template>

    <v-window v-model="step" vertical >
      <v-window-item >
        <v-card>
          <v-card-title class='grey lighten-4 py-1 overline' >
            Please confirm
          </v-card-title>
          <v-divider/>
          <v-card-text>
            This will copy the codes from this appointment to all the appointments in the recurring series
            <v-checkbox hide-details
              v-model='withClear'
              label='Clear any existing codes on other appointments' />

            <v-checkbox hide-details
              v-model='excludeInvoiced'
              label='Ignore invoiced and paid appointments' />
            <!-- {{appointment.start_time}} -->
            <v-checkbox persistent-hint
              v-model='onlyAfter'
              v-if='afterDate'
              :hint='`Only update appointments after ${afterDate}`'
              label='Only apply to appointments after this one' />
          </v-card-text>
          <v-divider/>
          <v-card-actions >
            <v-btn @click='dialog=false' flat >Cancel</v-btn>
            <v-spacer/>
            <v-btn @click='save' :loading='request.loading' color='primary' >Apply Codes</v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item >

      <v-window-item >
        <v-card>
          <v-card-title class='overline' >
            Codes successfully copied
          </v-card-title>
          <v-card-text v-if='request.result' >
            Codes copied to {{ request.result.clone_count }} appointments
          </v-card-text>
          <v-card-actions >
            <v-spacer/>
            <v-btn @click='step=0;dialog=false' >Done</v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item>
    </v-window>
  </v-card>
</v-dialog>
</template>
<script>
export default {
  name: 'ApplyAppointmentCodes',
  props: {
    appointment: { type: Object, required: true },
    cta: { type: String, default: 'Apply to all appointments in series' },
    disabled: { type: Boolean, required: false }
  },
  data () {
    return {
      step: 0,
      dialog: false,
      withClear: true,
      onlyAfter: false,
      excludeInvoiced: true,
      request: {
        resource: 'ag.practitioner.appointments',
        extra: 'actions/apply_codes',
        method: 'post'
      }
    }
  },
  computed: {
    appointmentId () { return this.appointment.id },
    requestStatus () { return this.request.status },
    afterDate () {
      if (this.appointment && this.appointment.start_time) {
        return this.appointment.start_time.split('T')[0]
      }
      return null
    }
  },
  watch: {
    appointmentId () {
      this.step = 0
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.step = 1
      }
    }
  },
  methods: {
    save () {
      this.request.resourceId = this.appointmentId
      this.request.data = {clear_existing_codes: this.withClear}
      if (this.onlyAfter && this.afterDate) {
        this.request.data.after = this.afterDate
      }
      if (this.excludeInvoiced === true) {
        this.request.data.exclude_statuses = 'I,P'
      }
      this.$request('save', this.request)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ApplyAppointmentCodes.vue?d9fa5ab8